export default "__VITE_ASSET__Bto1mGEe__"